import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { CertificateConfigForm } from "../../../components/reportConfig/form/CertificateConfigForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import { ReportType } from "../../../models/enums/reportType";
import type { Group } from "../../../models/group";
import type { CertificateConfiguration } from "../../../models/reportConfigs/certificateConfiguration";
import type { Signature } from "../../../models/signature";
import type { YearContext } from "../../../models/yearContext";
import { report_configurations_path } from "../../../routes";

type JumpCertificateConfigDuplicateProps = {
  jumpstart_config: CertificateConfiguration;
  year_contexts: YearContext[];
  groups: Group[];
  signatures: Signature[];
};

export default function JumpCertificateConfigDuplicate({
  year_contexts,
  groups,
  jumpstart_config,
  signatures,
}: JumpCertificateConfigDuplicateProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.post(pathWithYearContext(report_configurations_path), values);

  return (
    <ContentShell
      title={`JUMPStart Zertifikat-Vorlage ${jumpstart_config.title}`}
      onBack={() => router.get(pathWithYearContext(report_configurations_path))}
    >
      <CertificateConfigForm
        signatures={signatures}
        certificateConfig={jumpstart_config}
        yearContexts={year_contexts}
        groups={groups}
        saveButtonLabel="Erstellen"
        onSubmit={onSubmit}
        reportType={ReportType.JUMP}
      />
    </ContentShell>
  );
}
